import * as React from "react";

export function Icon({id = "", xLinkHref = "", sizeSettings = "", styleSettings = {}, onClick = () => {}, className = ""}) {
    return (
        <svg viewBox={sizeSettings} id={id} style={styleSettings} onClick={onClick} className={className}>
            <use xlinkHref={xLinkHref} />
        </svg>
    );
}
